var map = {
	"./Increase SABA dosage.jepg": 880,
	"./Switch to Symbicort.jpeg": 70,
	"./logo.png": 949,
	"./maintainance.jpeg": 630,
	"./tripleTherapy.jpeg": 217,
	"./video.mp4": 136,
	"./videoBackground.png": 426,
	"./videoPoster.png": 531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;